import type { DocumentLineInput } from '../types/documents.types';
import { isVisualDesignerLine } from './visualDesignerSurveyClone';

export type VersionSaveLines = {
  lines: DocumentLineInput[];
  /** The database keeps the designs already on the version and replaces only the commercial lines. */
  keepDesigns: boolean;
};

/**
 * Which lines a quote editor save writes. On an embedded estimate or quote the survey owns the
 * designs, so the editor writes only its commercial lines unless it is attaching designs itself.
 */
export function planVersionSaveLines(input: {
  current: DocumentLineInput[];
  embedded: boolean;
  isInvoice: boolean;
  attachingDesigns: DocumentLineInput[] | null;
}): VersionSaveLines {
  const { current, embedded, isInvoice, attachingDesigns } = input;
  if (!embedded || isInvoice) return { lines: current, keepDesigns: false };
  const commercial = current.filter((line) => !isVisualDesignerLine(line));
  if (attachingDesigns && attachingDesigns.length > 0) {
    return { lines: [...attachingDesigns, ...commercial], keepDesigns: false };
  }
  return { lines: commercial, keepDesigns: true };
}
